/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

/**
 * Resources that internal admin permissions apply to. Used by Swipe4Work.Core.Domains.Auth.Entities.AdminPermission.
 * Mirrors the customer-facing Swipe4Work.Core.Domains.Auth.Enums.PermissionResource but for the internal admin portal.
 */
export type AdminPermissionResource = typeof AdminPermissionResource[keyof typeof AdminPermissionResource];


export const AdminPermissionResource = {
  Company: 'Company',
  Job: 'Job',
  Employer: 'Employer',
  MatchingAlgorithm: 'MatchingAlgorithm',
  Simulations: 'Simulations',
  ExactOnline: 'ExactOnline',
  CompanyInvoicing: 'CompanyInvoicing',
  CompanyStatistics: 'CompanyStatistics',
  JobStatistics: 'JobStatistics',
  Candidates: 'Candidates',
  CompanyMedia: 'CompanyMedia',
  SalesMetrics: 'SalesMetrics',
  Skills: 'Skills',
  ReferalSources: 'ReferalSources',
  JobFunctions: 'JobFunctions',
  PersonaImport: 'PersonaImport',
  Webhooks: 'Webhooks',
  JobFunctionsISCO: 'JobFunctionsISCO',
  IntegrationErrors: 'IntegrationErrors',
} as const;
